import React from 'react'
import { Link } from 'react-router-dom'
// import * as RouterDom from 'react-router-dom'
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import 'react-overlay-loader/styles.css';

// Header
const Header = (props) => {

  // shadow2dp
  return (

    <div className="shadow2dp" style={{
      marginBottom: 60,
      // backgroundColor: '#0C3966',
      backgroundColor: '#ffffff',
    }}>

      <Container>

        <Row style={{
          paddingTop: 20,
          paddingBottom: 20,
          marginBottom: 20,
          fontSize: 18,
        }}>
          <Col md="6" xs="12" style={{
            textAlign: 'left',
          }}>
            <Link to="/">
              <img src={require("../../../images/shabelabo_logo_128.png")}
                style={{
                  marginRight: 20,
                  width: 40,
                  // height: 38,
              }} alt="shabelab log" />
            </Link>

          </Col>

          <Col md="6" xs="12" style={{
            textAlign: 'right',
          }}>
            <Link
              className="lineHeight50"
              style={{
                color: '#111111',
                textDecoration: 'none',
                // fontWeight: 'bold',
                marginRight: 8,
                marginLeft: 8,
              }}
              to="/docs_top">
              ドキュメント
            </Link>

            {/*<span style={{
              color: '#cccccc'
            }}>
              |
            </span>*/}

            {window.location.hostname === "localhost" && (
              <>
              <Link
                className="lineHeight50"
                style={{
                  color: '#111111',
                  textDecoration: 'none',
                  // fontWeight: 'bold',
                  marginRight: 8,
                  marginLeft: 8,
                }}
                to="/create_account">
                アカウントの作成
              </Link>
              </>
            )}

            {window.location.hostname === "localhost" && (
              <span style={{
                color: '#cccccc'
              }}>
                |
              </span>
            )}

            <Link
              className="lineHeight50"
              style={{
                color: '#111111',
                textDecoration: 'none',
                // fontWeight: 'bold',
                marginRight: 8,
                marginLeft: 8,
              }}
              to="/login">
              ログイン
            </Link>
          </Col>

        </Row>
      </Container>

    </div>
  )
}

export default Header
